import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { MetaTagsList } from '@corefront/seo-tools';
import {
  THEME_DETAIL_PAGINATED,
  CATEGORY_DETAIL_PAGINATED,
  PROVIDER_DETAIL_PAGINATED,
} from '../../../constants/routeTemplates';

export const pagesWithMetaRobotsNoIndex = [
  THEME_DETAIL_PAGINATED,
  CATEGORY_DETAIL_PAGINATED,
  PROVIDER_DETAIL_PAGINATED,
];

export const SEOMetaTagData = [
  {
    tagName: 'meta',
    tagContent: null,
    tagAttributes: [
      {
        name: 'content',
        value: 'noindex, follow',
      },
    ],
  },
];

const MetaRobots = () => {
  const { path } = useRouteMatch();

  return pagesWithMetaRobotsNoIndex.includes(path) ? (
    <MetaTagsList data={SEOMetaTagData} />
  ) : null;
};

export default MetaRobots;
